
import Image from "next/image";

const ProductCard = ({ product }) => {
  return (
    <a
      href={`/${product?.post_name}`}
      title={product?.post_title}
      className="h-full no-underline"
    >
      <div className="w-full h-full sm:pt-10 sm:px-6 sm:pb-6 sm:bg-white group sm:rounded-10">
        <div className="flex items-center justify-center w-full">
          <div className="flex flex-col w-full gap-2 sm:gap-6">
            <div className="relative flex items-center w-auto h-56 p-4 overflow-hidden bg-white rounded-md md:h-full md:rounded-none sm:bg-transparent md:p-2 md:aspect-square">
              <Image
                src={product?.thumbnail?.url || "/images/placeholder.png"}
                alt={product?.thumbnail?.alt || "placeholder"}
                className="!relative object-contain w-auto transition-all duration-300 sm:!h-full group-hover:scale-105"
                fill
              />
            </div>
            <div className="flex flex-col gap-1">
              {product?.main_category?.name && (
                <span className="text-sm font-normal text-dark-text md:text-15">
                  {product?.main_category?.name}
                </span>
              )}
              <span className="text-sm font-black text-dark-text md:text-15">
                {product?.post_title}
              </span>
              <span className="text-sm font-normal text-dark-text md:text-15">
                {product?.subtitel}
              </span>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

export default ProductCard;
